import numberInput from './components/numberInput'
import textAreaInput from './components/textAreaInput'
import textInput from './components/textInput'
import inputLabel from './components/inputLabel'
import imageUploadInput from './components/imageUploadInput'
import checkBoxInput from './components/checkboxInput'
import singleCheckBoxInput from './components/singleCheckboxInput'

export const TextInput = textInput
export const TextAreaInput = textAreaInput
export const NumberInput = numberInput
export const InputLabel = inputLabel
export const ImageUploadInput = imageUploadInput
export const CheckBoxInput = checkBoxInput
export const SingleCheckBoxInput = singleCheckBoxInput